import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const WeightPageHistoryPage = lazy(() => import("./WeightPageHistoryPage"));

const WeightPageHistoryPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <WeightPageHistoryPage />
    </Suspense>
  );
};

export default WeightPageHistoryPageLazy;
